
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about/goodies",
      function () {
        return require("private-next-pages/about/goodies/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/about/goodies"])
      });
    }
  